import styled from 'styled-components'

import { helpers } from 'styles'

export const Content = styled.div`
	color: ${helpers.color.text};
	padding: 12px 16px;
`
